var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('title-row', {
    attrs: {
      "title": _vm.page.title,
      "subtitle": _vm.page.subtitle,
      "breadcrumb-items": [{
        text: 'Időszakok',
        to: {
          name: 'DateIntervalList'
        }
      }, _vm.page.breadcrumbItem]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('title-row-button', {
          attrs: {
            "disabled": _vm.loading
          },
          on: {
            "click": _vm.save
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Mentés ")], 1)];
      },
      proxy: true
    }])
  }), _c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Megnevezés",
      "error-messages": _vm.errors.name,
      "filled": ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('v-row', {
    staticClass: "m-1"
  }, [_c('v-col', {
    attrs: {
      "cols": 12,
      "md": 6
    }
  }, [_c('v-datetime-picker', {
    attrs: {
      "label": "Kezdő dátum",
      "error-messages": _vm.errors.start_date,
      "timePicker": false,
      "datePicker": "",
      "filled": ""
    },
    model: {
      value: _vm.form.start_date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "start_date", $$v);
      },
      expression: "form.start_date"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12,
      "md": 6
    }
  }, [_c('v-datetime-picker', {
    attrs: {
      "label": "Záró dátum",
      "error-messages": _vm.errors.end_date,
      "timePicker": false,
      "datePicker": "",
      "filled": ""
    },
    model: {
      value: _vm.form.end_date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "end_date", $$v);
      },
      expression: "form.end_date"
    }
  })], 1)], 1), _c('v-switch', {
    attrs: {
      "inset": "",
      "messages": "Ez az időszak minden évben ismétlődni fog a megadott kezdő és záró dátum között.",
      "label": "Évente ismétlődő időszak"
    },
    model: {
      value: _vm.form.is_recurring,
      callback: function ($$v) {
        _vm.$set(_vm.form, "is_recurring", $$v);
      },
      expression: "form.is_recurring"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }